module.exports = __webpack_public_path__ + "static/media/libro18.da64554f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro18.png
// module id = 366
// module chunks = 0